import React, { useEffect, useState } from "react";
import axios from "axios";

import styled from "styled-components";
import moment from "moment";
import { Spin, Select, DatePicker, Table } from "antd";
import { columnsUsers, columnsUrls, dispatchUrls, getUrlsBacklogs, getUsersRolesAndClients } from "./Backlogs.utils";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";

const { Option } = Select;

const Filter = ({ item, selectedItem, fetchDistinct, onChange, placeholder, token, width, filters }) => {
  const [items, setItems] = useState([]);

  return (
    <Select
      allowClear={true}
      showSearch
      placeholder={placeholder}
      style={{ width: width || 200, margin: 5 }}
      value={selectedItem}
      onFocus={async () => {
        const response = await fetchDistinct(item, token, filters);
        setItems(response);
      }}
      onChange={onChange}
    >
      {items.map(client => (
        <Option key={client} value={client}>
          {client}
        </Option>
      ))}
    </Select>
  );
};

const BackLogs = ({ token, available }) => {
  if (!available) return <div>Vous n'avez pas accès à cette page</div>;

  const [isLoading, setIsLoading] = useState(false);
  const [nbUsers, setNbUsers] = useState([]);
  const [nbVisits, setNbVisits] = useState([]);
  const [urls, setUrls] = useState([[], [], [], []]); // [urls1, urls2, urls3, urls4]
  const [users, setUsers] = useState([]);
  const [rangeDate, setRangeDate] = useState([moment().startOf("week"), moment().endOf("week")]);

  useEffect(() => {
    const fetchUsersInfo = async () => {
      const emails = await fetchDistinct("email", token, {
        match: { created_at: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } } }
      });
      const users = await getUsersRolesAndClients(emails, token);
      setUsers(users);
    };
    const fetchDatas = async () => {
      setIsLoading(true);
      const { urls: resultUrls1, nbVisits: nbVisits1, nbUsers: nbUsers1 } = await getUrlsBacklogs(token, rangeDate);

      setUrls([resultUrls1, urls[1], urls[2], urls[3]]);
      setNbUsers([nbUsers1, nbUsers[1], nbUsers[2], nbUsers[3]]);
      setNbVisits([nbVisits1, nbVisits[1], nbVisits[2], nbVisits[3]]);
      setIsLoading(false);
      
    };

    if (urls[1].length > 0) fetchDatas();
    fetchUsersInfo();
  }, [rangeDate]);

  useEffect(() => {
    const fetchDatas = async () => {
      setIsLoading(true);
      const { urls: resultUrls1, nbVisits: nbVisits1, nbUsers: nbUsers1 } = await getUrlsBacklogs(token, rangeDate);
      const { urls: resultUrls2, nbVisits: nbVisits2, nbUsers: nbUsers2 } = await getUrlsBacklogs(token, [
        moment()
          .add(-1, "week")
          .startOf("week"),
        moment()
          .add(-1, "week")
          .endOf("week")
      ]);
      const { urls: resultUrls3, nbVisits: nbVisits3, nbUsers: nbUsers3 } = await getUrlsBacklogs(token, [
        moment()
          .add(-1, "week")
          .add(-1, "month")
          .startOf("week"),
        moment()
          .add(-1, "week")
          .add(-1, "month")
          .endOf("week")
      ]);
      const { urls: resultUrls4, nbVisits: nbVisits4, nbUsers: nbUsers4 } = await getUrlsBacklogs(token, [
        moment()
          .add(-1, "week")
          .add(-3, "month")
          .startOf("week"),
        moment()
          .add(-1, "week")
          .add(-3, "month")
          .endOf("week")
      ]);
      setUrls([resultUrls1, resultUrls2, resultUrls3, resultUrls4]);
      setNbUsers([nbUsers1, nbUsers2, nbUsers3, nbUsers4]);
      setNbVisits([nbVisits1, nbVisits2, nbVisits3, nbVisits4]);
      setIsLoading(false);
    };

    fetchDatas();
  }, []);

  const filters = { match: { created_at: { $gte: { $date: rangeDate[0] }, $lte: { $date: rangeDate[1] } } } };
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`backlogs`}</div>
        </div>

        <DatePicker.RangePicker
          onChange={selectedRangeDate => {
            setRangeDate(selectedRangeDate);
          }}
          defaultValue={rangeDate}
          format={"DD/MM/YYYY"}
          placeholder={["Début", "Fin"]}
        />
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Filter
            fetchDistinct={fetchDistinct}
            item={"email"}
            placeholder={"email"}
            token={token}
            width={400}
            filters={filters}
          />
          <Filter
            fetchDistinct={fetchDistinct}
            item={"url"}
            placeholder={"url"}
            token={token}
            width={400}
            filters={filters}
          />
        </div>
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <div>
            <div className="bg-white p-8 shadow-lg rounded">
              <h1 className="text-2xl mb-4">Les urls</h1>
              <Table
                columns={columnsUrls(rangeDate)}
                dataSource={dispatchUrls(nbUsers, nbVisits, urls)}
                pagination={false}
              />
            </div>
            <div className="bg-white p-8 shadow-lg rounded">
              <h1 className="text-2xl mb-4">
                Les utilisateurs (
                {`manager : ${users.filter(u => u.role_label === "Manager").length}
                terrain : ${users.filter(u => u.role_label === "Terrain").length} `}
                )
              </h1>
              <Table columns={columnsUsers(rangeDate)} dataSource={users} pagination={false} />
            </div>
          </div>
        )}
      </React.Fragment>
    </Container>
  );
};

export default BackLogs;

const fetchDistinct = async (item, token, filters) => {
  return axios
    .post(`${baseapi}/backlogs/distincts/${item}`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/pages/devs/backLogs/BackLogs.js